<template>
	<div class="home">

		<!-- 顶部工具栏：搜索、添加、导出 -->
		<div class="search_line">
			<div class="first_search_line">
				<el-autocomplete v-if="userType=='admin'" class="auto_comp" clearable v-model="search_data.school_name"
					:fetch-suggestions="querySearch" size="mini" placeholder="学校" />
				<el-select style="width: 200px;margin-left: 20px;margin-right: 20px;" v-model="search_data.level" clearable
					placeholder="学历" size="mini">
					<el-option v-for="item in ['初中','高中']" :key="item" :label="item" :value="item">
					</el-option>
				</el-select>
				<!-- 				<el-tooltip effect="dark" content="如: 2020" placement="top-start">
					<el-input style="width: 200px;margin-right: 20px;" clearable v-model="search_data.grade" size="mini"
						placeholder="年级" />
				</el-tooltip> -->
				<el-date-picker style="width: 200px;margin-right: 20px;" size="mini" v-model="search_data.grade"
					type="year" placeholder="入学年份" value-format="yyyy">
				</el-date-picker>
				<!-- 				<el-select style="width: 200px;margin-right: 20px;" v-model="search_data.major" clearable
					placeholder="专业" size="mini">
					<el-option v-for="item in major_options" :key="item" :label="item" :value="item">
					</el-option>
				</el-select> -->
				<el-input style="width: 200px;margin-right: 20px;" v-if="userType=='admin' || userType=='school'"
					clearable v-model="search_data.teacher_name" size="mini" placeholder="教师" />
			</div>
			<div class="second_search_line">
				<el-button class="search_bt" type="danger" icon="el-icon-search" size="mini" @click="getClassInfo()">
					搜索
				</el-button>
				<el-button class="search_bt" type="primary" icon="el-icon-plus" size="mini" @click="handleAdd()"
					v-if="userinfo.permit!='1'">
					添加
				</el-button>
				<!-- 				<el-button class="export_bt" type="success" icon="el-icon-download" size="mini">
					导出
				</el-button> -->
			</div>
		</div>

		<!-- 内容表格 -->
		<el-table :data="tableData" :header-cell-style="{background:'#409EFF',color:'white'}" size="mini">
			<el-table-column prop="name" label="名称" />
			<el-table-column prop="grade" label="年级" />
			<!-- <el-table-column prop="major" label="专业" /> -->
			<el-table-column prop="studentNums" label="学生人数" />
			<el-table-column prop="teacherName" label="教师姓名" />
			<el-table-column prop="schoolName" label="学校名称" width="280" />

			<el-table-column prop="edit" label="修改" width="60" v-if="userinfo.permit!='1'">
				<template slot-scope="scope">
					<el-button @click="handleEdit(scope.row)" type="text" size="mini" class="edit_bt"><i
							class="el-icon-edit-outline"></i></el-button>
				</template>
			</el-table-column>
			<el-table-column prop="delete" label="删除" width="60" v-if="userinfo.permit!='1'">
				<template slot-scope="scope">
					<el-button type="text" size="mini" class="delete_bt" @click="handleDelete(scope.row)"><i
							class="el-icon-delete"></i>
					</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div class="pagination">
			<el-pagination background layout="total, prev, pager, next" @current-change="handleCurrentChange"
				:total="total_num">
			</el-pagination>
		</div>

		<!-- 添加弹窗 -->
		<el-dialog title="添加班级" :visible.sync="dialogteacherAddVisible" top="5vh">
			<div class="input_title">
				<span>学校名称</span>
				<span v-show="showTip">
					<font>{{result}}</font>
				</span>
			</div>
			<div>
				<el-autocomplete :disabled="userType!='admin'" clearable
					v-model="updata.school_name" :fetch-suggestions="querySearch" size="small" placeholder="请输入学校名称"
					suffix-icon="el-icon-office-building" style="width: 80%;"/>
			</div>
			<div class="input_title">
				<span>教师</span>
			</div>
			<div :disabled="userType=='teacher'">
				<el-autocomplete :disabled="userType=='teacher'" clearable
					v-model="updata.teacher_name" :fetch-suggestions="querySearchTeacher" size="small"
					placeholder="请输入教师姓名" readonly @select="handleTeacherSelect" style="width: 80%;">
					<i class="el-icon-s-custom el-input__icon" slot="suffix">
					</i>
					<template slot-scope="{ item }">
						<div class="teacher_tip" style="display: flex;justify-content: space-between;">
							<span>{{ item.value }}</span>
							<span>{{ item.male }}</span>
							<span>{{ item.phone }}</span>
							<span>{{ item.name }}</span>
						</div>
					</template>
				</el-autocomplete>
			</div>
			<div class="input_title">
				<span>初中/高中</span>
			</div>
			<div>
				<el-select style="width: 80%;margin-left: 0%;" v-model="updata.level" placeholder="请选择初中/高中" size="small">
					<el-option v-for="item in ['初中','高中']" :key="item" :label="item" :value="item">
					</el-option>
				</el-select>
			</div>
			<div class="input_title">
				<span>年级</span>
			</div>
			<div>
				<el-date-picker size="small" v-model="updata.grade" type="year" placeholder="入学年份" value-format="yyyy">
				</el-date-picker>
			</div>
			<div class="input_title">
				<span>班级名称</span>
			</div>
			<div>
				<el-input size="small" placeholder="请输入班级名称" v-model="updata.class_name" suffix-icon="el-icon-edit"
					@focus="showTip=false" />
			</div>

			<div slot="footer" class="dialog-footer">
				<el-button size="small" type="primary" @click="dialogteacherAddVisible = false">
					取 消
				</el-button>
				<el-button size="small" type="primary" @click="add()">
					确 定
				</el-button>
			</div>
		</el-dialog>

		<!-- 修改 -->
		<el-dialog title="修改" :visible.sync="dialogteacherEditVisible" top="5vh">
			<div class="input_title">
				<span>学校名称</span>
				<span v-show="showTip">
					<font>{{result}}</font>
				</span>
			</div>
			<div>
				<el-autocomplete :disabled="userType!='admin'" style="width: 80%;" clearable
					v-model="updata.school_name" :fetch-suggestions="querySearch" size="small" placeholder="请输入学校名称"
					suffix-icon="el-icon-office-building" />
			</div>
			<div class="input_title" v-if="userType=='admin' || userType=='school'">
				<span>教师</span>
			</div>
			<div v-if="userType=='admin' || userType=='school'" :disabled="userType=='teacher'">
				<el-autocomplete :disabled="userType=='teacher'" style="width: 80%;" clearable
					v-model="updata.teacher_name" :fetch-suggestions="querySearchTeacher" size="small"
					placeholder="请输入教师姓名" readonly @select="handleTeacherSelect">
					<i class="el-icon-s-custom el-input__icon" slot="suffix">
					</i>
					<template slot-scope="{ item }">
						<div class="teacher_tip" style="display: flex;justify-content: space-between;">
							<span>{{ item.value }}</span>
							<span>{{ item.male }}</span>
							<span>{{ item.phone }}</span>
							<span>{{ item.name }}</span>
						</div>
					</template>
				</el-autocomplete>
			</div>
			<div class="input_title">
				<span>学历</span>
			</div>
			<div>
				<el-select style="width: 80%;margin-left: 0%;" v-model="updata.level" placeholder="请选择初中/高中" size="small">
					<el-option v-for="item in ['初中','高中']" :key="item" :label="item" :value="item">
					</el-option>
				</el-select>
			</div>
			<div class="input_title">
				<span>年级</span>
			</div>
			<div>
				<el-date-picker size="small" v-model="updata.grade" type="year" placeholder="入学年份" value-format="yyyy">
				</el-date-picker>
			</div>
			<div class="input_title">
				<span>班级名称</span>
			</div>
			<div>
				<el-input size="small" placeholder="请输入班级名称" v-model="updata.class_name" suffix-icon="el-icon-edit"
					@focus="showTip=false" />
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" type="primary" @click="dialogteacherEditVisible = false">
					取 消
				</el-button>
				<el-button size="small" type="primary" @click="edit()">
					确 定
				</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: "teacher",
		data() {
			return {
				search_data: {
					school_name: '',
					level: '',
					grade: '',
					// major: '',
					teacher_name: ''
				},
				updata: {
					school_name: '',
					class_name: '',
					level: '',
					grade: '',
					// major: '',
					class_id: '',
					teacher_id: '',
					teacher_name: ''
				},
				state: '',
				tableData: [],
				total_num: 0,
				dialogteacherAddVisible: false,
				showTip: false,
				result: '',
				dialogteacherEditVisible: false,
				userType: window.localStorage.getItem("userType"),
				// major_options: ['田径', '体操', '足球', '篮球', '武术', '排球', '游泳'],
				userinfo: '',
			};
		},
		mounted() {
			this.getClassInfo();
		},
		methods: {
			getClassInfo(page) {
				page = !page ? 1 : page
				const that = this
				let data = {
					userType: that.userType,
					page: page,
					school_name: that.search_data.school_name,
					level: that.search_data.level,
					grade: that.search_data.grade,
					// major: that.search_data.major,
					teacher_name: that.search_data.teacher_name,
				}
				// 获取班级信息
				this.$axios({
					method: 'post',
					url: '/jfapi/getClassInfo',
					data: that.qs.stringify(data),
				}).then(function(res) {

					that.tableData = res.data.records
					that.total_num = res.data.total
				});

				// 获取用户信息
				that.$axios({
					url: '/jfapi/userinfo/' + that.userType
				}).then(function(res) {
					that.userinfo = res.data
				})
			},

			handleCurrentChange(val) {
				this.currentPage = val;
				this.getClassInfo(val)
			},

			querySearch(queryString, cb) {
				queryString = !queryString ? "" : queryString
				this.$axios({
					url: '/jfapi/getSchollHint?queryString=' + queryString,
				}).then(function(res) {
					cb(res.data)
				});
			},

			querySearchTeacher(queryString, cb) {
				queryString = ""
				if (this.updata.school_name == '') {
					return
				}
				const that = this
				this.$axios({
					url: '/jfapi/getTeacherHint?queryString=' + queryString + '&school_name=' + that.updata
						.school_name + '&userType=' + that.userType,
				}).then(function(res) {
					cb(res.data)
				});
			},

			handleAdd(row) {
				this.dialogteacherAddVisible = true
				this.updata.school_name = this.userinfo.schoolName
				this.updata.level = ''
				this.updata.grade = ''
				this.updata.class_name = ''
				this.updata.teacher_id = ''
				this.updata.teacher_name = ''
			},

			add() {
				for (let key in this.updata) {
					let item = this.updata[key]
					if (item == '' && key != 'class_id') {
						this.result = "请填写" + key
						this.showTip = true
						return
					}
				}
				let data = {
					userType: this.userType,
					school_name: this.updata.school_name,
					level: this.updata.level,
					grade: this.updata.grade,
					// major: this.updata.major,
					class_name: this.updata.class_name,
					teacher_id: this.updata.teacher_id
				}
				const that = this
				this.$axios({
					method: 'post',
					url: '/jfapi/addClass',
					data: that.qs.stringify(data)
				}).then(function(res) {
					if (res.data == 'success') {
						that.getClassInfo()
						that.dialogteacherAddVisible = false
					} else {
						that.result = res.data
						that.showTip = true
					}
				});
			},

			handleEdit(row) {
				this.dialogteacherEditVisible = true
				this.updata.school_name = row.schoolName
				this.updata.level = row.grade.substr(0, 1) + '中'
				this.updata.grade = row.grade.substr(1, 4)
				// this.updata.major = row.major
				this.updata.class_name = row.name
				this.updata.class_id = row.id
				this.updata.teacher_name = row.teacherName
				this.updata.teacher_id = row.teacherId
			},

			handleDelete(row) {
				var r = confirm("确认删除吗？");
				if (r == true) {
					const that = this
					this.$axios({
						url: '/jfapi/delClass?id=' + row.id + '&userType=' + that.userType,
					}).then(function(res) {
						that.getClassInfo()
					});
				}

			},

			edit() {
				for (let key in this.updata) {
					let item = this.updata[key]
					if (item == '') {
						this.result = "请填写" + key
						this.showTip = true
						return
					}
				}
				let data = {
					userType: this.userType,
					school_name: this.updata.school_name,
					teacher_workId: this.updata.teacher_workId,
					level: this.updata.level,
					grade: this.updata.grade,
					// major: this.updata.major,
					class_name: this.updata.class_name,
					class_id: this.updata.class_id,
					teacher_id: this.updata.teacher_id
				}
				const that = this
				this.$axios({
					method: 'post',
					url: '/jfapi/editClass',
					data: that.qs.stringify(data)
				}).then(function(res) {
					if (res.data == 'success') {
						that.getClassInfo()
						that.dialogteacherEditVisible = false
					} else {
						that.result = res.data
						that.showTip = true
					}
				});
			},

			handleTeacherSelect(item) {
				this.updata.teacher_id = item.id
				// console.log(this.updata.teacher_id)
			},
		}
	};
</script>

<style lang="scss" scoped>
	.search_line {
		display: flex;
		width: 90%;
		flex-wrap: wrap;
		justify-content: space-between;
		padding-left: 10px;
		padding-right: 10px;
	}

	.first_search_line {
		width: 100%;
		display: flex;
		margin-left: 22px;
		justify-content: flex-start;
	}

	.second_search_line {
		width: 80%;
		display: flex;
		justify-content: flex-start;
		margin-left: 18px;
		margin-top: 10px;
	}

	.auto_comp {
		width: 250px;
	}

	.auto_comp .el-input {
		width: 80%;
	}

	input {
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
	}

	.search_bt {
		margin-left: 5px;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
	}

	.export_bt {
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
	}

	.el-table {
		margin-top: 10px;
		font-size: small;
		width: 96%;
		margin-left: 2%;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1) // box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
	}

	.edit_bt {
		color: #00ff7f;
	}

	.delete_bt {
		color: red;
	}

	.pagination {
		width: 90%;
		margin-left: 5%;
		margin-top: 10px;
		display: flex;
		justify-content: flex-end;
	}

	.input_title span {
		margin: 0;
		color: #959595;
		font-size: 10px;
	}

	.input_title {
		display: flex;
		justify-content: space-between;
		width: 80%;
		margin-left: 10%;
		margin-top: 10px;
	}

	// .el-input {
	// 	width: 80%;
	// }

	.el-input__inner:focus {
		border-color: #00b27a;
	}

	.el-dialog__body {
		padding: 0;
	}

	.el-dialog {
		width: 40%;
		padding-top: 20px;
		padding-bottom: 20px;
	}

	.el-dialog .el-autocomplete {
		width: 100%;
	}

	font {
		color: #ff0000;
		margin-right: 10px;
	}

	.el-dialog div .el-input {
		width: 80%;
	}

	.el-dialog div .el-select {
		width: 100%;
		margin-left: 10%;
	}
</style>
